import { GzSelectedListItemWebComponent } from './component/GzSelectedListItemWebComponent';

export { GzSelectedListItemWebComponent };
